function getColorBrightness(rgbColor) {
  var colorValues = rgbColor.match(/[\d\.]+/g).map(Number);
  return 0.2126 * (colorValues[0] / 255) + 0.7152 * (colorValues[1] / 255) + 0.0722 * (colorValues[2] / 255);
}

function isSimilarToBackground(color) {
  var backgroundColor = 'rgb(255, 255, 255)';

  var colorBrightness = getColorBrightness(color);
  var backgroundColorBrightness = getColorBrightness(backgroundColor);

  return (backgroundColorBrightness / colorBrightness) < 1.5;
}

var SwatchColors = (function() {
  function SwatchColors() {
    this.colors = {'true-royal': 'rgb(49, 71, 140)','military-green': 'rgb(84, 87, 68)','deep-heather': 'rgb(89, 94, 73)','asphalt': 'rgb(88, 88, 88)','athletic-heather': 'rgb(177, 177, 177)','mauve': 'rgb(175, 122, 116)','natural': 'rgb(233, 219, 197)','white': 'rgb(255, 255, 255)','dark-heather': 'rgb(50, 47, 48)','orchid': 'rgb(216, 166, 170)','heather-magenta': 'rgb(176, 102, 138)','heather-deep-teal': 'rgb(98, 130, 142)','blue-lagoon': 'rgb(140, 168, 171)','dusty-blue': 'rgb(174, 199, 188)','athletic-grey': 'rgb(212, 210, 211)','heather-prism-blue': 'rgb(199, 211, 226)','vintage-white': 'rgb(241, 236, 231)','silver-athletic-grey': 'rgb(216, 213, 214)','vintage-black': 'rgb(26, 25, 27)','heather-navy': 'rgb(41, 47, 80)','black': 'rgb(0, 0, 0)','red': 'rgb(206, 31, 49)','white': 'rgb(255, 255, 255)','navy': 'rgb(24, 30, 46)','true-royal': 'rgb(49, 71, 140)','military-green': 'rgb(84, 87, 68)','mauve': 'rgb(175, 122, 116)','natural': 'rgb(254, 245, 223)','vintage-black': 'rgb(26, 25, 27)','dark-grey': 'rgb(96, 95, 99)','light-orange': 'rgb(255, 181, 155)','watermelon': 'rgb(226, 75, 82)','stonewash-denim': 'rgb(164, 182, 197)','dark-grey-heather': 'rgb(28, 27, 28)','deep-heather': 'rgb(73, 73, 73)','athletic-heather': 'rgb(166, 167, 172)','sunset': 'rgb(219, 145, 117)','coral': 'rgb(224, 93, 73)','sand': 'rgb(207, 201, 188)','vintage-sand': 'rgb(223, 215, 201)','vintage-denim': 'rgb(126, 142, 155)','vintage-red': 'rgb(190, 80, 96)','vintage-navy': 'rgb(81, 92, 102)','vintage-white': 'rgb(230, 227, 222)',};

    this.images = {};

    this.triggers = ['color','colour','couleur','farbe','cor',];
  }

  function setSwatchColor(swatch) {
    var swatchId = swatch.getAttribute('swatch-id');

    if (Object.keys(this.colors).includes(swatchId)) {
      swatch.style.setProperty("--background-graphic", this.colors[swatchId]);

      if (isSimilarToBackground(this.colors[swatchId])) swatch.classList.add('is-similar-to-background');
      if (getColorBrightness(this.colors[swatchId]) > 0.5) {
        swatch.style.setProperty('--tick-color', '#000');
      } else {
        swatch.style.setProperty('--tick-color', '#fff');
      }
      swatch.classList.remove('is-blank');
    }

    if (Object.keys(this.images).includes(swatchId)) {
      swatch.style.setProperty("--background-graphic", this.images[swatchId]);
      swatch.classList.add('is-image');
      swatch.classList.remove('is-blank');
    }
  }
  SwatchColors.prototype.setSwatchColor = setSwatchColor;

  return SwatchColors;
}());

const Swatches = new SwatchColors();

function VariantSwatch() {
  return Reflect.construct(HTMLElement, [], this.constructor);
}

VariantSwatch.prototype = Object.create(HTMLElement.prototype);
VariantSwatch.prototype.constructor = VariantSwatch;
Object.setPrototypeOf(VariantSwatch, HTMLElement);

VariantSwatch.prototype.connectedCallback = function() {
  Swatches.setSwatchColor(this);
};
customElements.define('variant-swatch', VariantSwatch);

export default Swatches;
